import api from '@/services/api'

/**
 * 获取批发报价列表
 */
export function getPackageList(wholesalerId) {
  // 从 localStorage 获取批发商 ID
  const wid = wholesalerId || localStorage.getItem('stored_wholesaler_id') || 
              JSON.parse(localStorage.getItem('userInfo') || '{}').wholesalerId
  return api.get('/wholesaler/packages', { params: { wholesalerId: wid } })
}

/**
 * 获取档口列表（批发商的客户）
 */
export function getCustomerList() {
  return api.get('/wholesaler/customers')
}

/**
 * 创建批发报价
 */
export function createPackage(data) {
  // ⭐ 添加 wholesalerId（从 localStorage 获取）
  const wholesalerId = localStorage.getItem('stored_wholesaler_id') || 
                       JSON.parse(localStorage.getItem('userInfo') || '{}').wholesalerId
  if (wholesalerId) {
    data.wholesalerId = wholesalerId
  }
  return api.post('/wholesaler/packages', data)
}

/**
 * 更新批发报价
 */
export function updatePackage(id, data) {
  // ⭐ 添加 wholesalerId（从 localStorage 获取）
  const wholesalerId = localStorage.getItem('stored_wholesaler_id') || 
                       JSON.parse(localStorage.getItem('userInfo') || '{}').wholesalerId
  if (wholesalerId) {
    data.wholesalerId = wholesalerId
  }
  return api.put(`/wholesaler/packages/${id}`, data)
}

/**
 * 获取批发报价详情
 */
export function getPackageDetail(id) {
  return api.get(`/wholesaler/packages/${id}`)
}

/**
 * 复制批发报价
 */
export function copyPackage(id) {
  return api.post(`/wholesaler/packages/${id}/copy`)
}

/**
 * 失效批发报价
 */
export function deactivatePackage(id) {
  return api.put(`/wholesaler/packages/${id}/deactivate`)
}

/**
 * 重新生效批发报价
 */
export function activatePackage(id) {
  return api.put(`/wholesaler/packages/${id}/activate`)
}
